import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { getSelectedUser } from '../../store/users/selectors';
import { IUser } from '../../store/interface';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import ResetPasswordForm from './resetPasswordForm';
import BlobUtil from '../../utils/blobUtil'
import UserTopNav from '../../components/userTopNav';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, Container } from 'reactstrap';

import { listRequest as listRequestAction,
    createRequest as createRequestAction,
    updateRequest as updateRequestAction,
    deleteRequest as deleteRequestAction,
    resetPasswordRequest as resetPasswordRequestAction,
    selectData as selectDataAction, 
    selectedData as selectedAction,
    selectedClear as selectedClearAction
} from '../../store/users/actions';

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    ui : any
}

interface IState {
    loaded : boolean
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction
    createRequest : typeof createRequestAction
    updateRequest : typeof updateRequestAction
    deleteRequest : typeof deleteRequestAction
    resetPasswordRequest : typeof resetPasswordRequestAction
    selectData : typeof selectDataAction
    selectedData : typeof selectedAction
    selectedClear : typeof selectedClearAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class UserResetPasswordPage extends React.Component<AllProps, IState> {
    blobUtil: BlobUtil;
    constructor(props: AllProps) {
        super(props);
        this.state = {
            loaded : false
        };
        this.blobUtil = new BlobUtil();
        this.readData = this.readData.bind(this);
        this.createOrUpdateData = this.createOrUpdateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
    }

    public componentDidMount() {
        let id = this.props.route.match.params.id;
        this.props.selectData(id);
    }
    public componentWillUnmount() {
        //this.props.selectedClear();  
    } 

    readData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.ui.selected;
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listRequest(searchParams);
    }

    async componentDidUpdate(prevProps: AllProps) {
        //console.log("componentDidUpdate : " + this.props.ui.selected);
        // Load data if direct access from link
        if (prevProps.ui.selected === undefined && this.props.ui.selected != undefined && this.props.data === undefined){
            this.readData();
        }

        // Load data to state for chanages
        // if ((this.props.ui.processState !== 3) && (
        //     (prevProps.data === undefined && this.props.data !== undefined) || 
        //         //(this.props.ui?.selected !== "")
        //         (prevProps.data?.id !== this.props.data?.id)
        //     )){

        //     this.props.selectedData();
        // }
        if (this.props.ui.processState !== 3 && this.props.data !== undefined && !this.state.loaded
            && this.props.data?.id === this.props.ui.selected){
            this.setState({ loaded : true}, () => {
                this.props.selectedData();
            })
        }

        // Show notification
        if ((prevProps.data?._etag != this.props.data?._etag) || 
            (prevProps.ui.processState != this.props.ui.processState) ){
            let notification = { show : false, title:"", type: "", message : "" };

            if (this.props.ui.processState === 1){ // Create/Update success
                notification.show = true;
                notification.type = "success";
                notification.message = "Password reset successfully";
                
            } else if (this.props.ui.processState === 2){ // Create/Update failed
                notification.show = true;
                notification.type = "danger";
                notification.message =  "Process failed. Error : \n" + this.props.ui.errors;
            } else if (this.props.ui.processState === 3){ // Delete success
                // Show custom dialaog box
            } else if (this.props.ui.processState === 4){ // Delete failed
                notification.show = true;
                notification.type = "danger";
                notification.message =  "Delete failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show){
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                }); 
            }
        }
    }
    
   
    createOrUpdateData = async (formData:any) => {
        this.props.resetPasswordRequest({
            userOId : formData.userOId,
            password : formData.newPassword,
            confirmPassword : formData.confirmNewPassword
        });

    }

    deleteData = async (doc:IUser) => {
        this.props.deleteRequest(doc);
    }
        
    public render() { 
        return (
            <div>
                {this.props.ui.loading ? 
                    (
                        <div>Loading data&nbsp;<Spinner color="warning">Loading</Spinner></div>
                    )
                    :
                    (
                        <Container>
                            <UserTopNav activeTab = "Password" selectedUserId ={this.props.ui.selected} />
                            <ResetPasswordForm 
                                props = {this.props} 
                                read = {this.readData}
                                save = {this.createOrUpdateData}
                                remove = {this.deleteData}
                            />
                        </Container>
                    )
                }
                
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.user.ui,
    data: getSelectedUser(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction,
    createRequest : createRequestAction,
    updateRequest : updateRequestAction,
    deleteRequest : deleteRequestAction,
    resetPasswordRequest : resetPasswordRequestAction,
    selectData : selectDataAction,
    selectedData : selectedAction,
    selectedClear : selectedClearAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserResetPasswordPage)
